export default __webpack_public_path__ + "static/media/home-icon-active.eba95d88.webp";